// angular
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';

// others
import { PatientRegistrationService } from './patient-registration.service';
import { AppService } from '../app.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../shared/base.component';
import { AuthService } from '../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../shared/base.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-patient-registration',
    templateUrl: './patient-registration.component.html',
    styleUrls: ['patient-registration.component.scss'],
    providers: [PatientRegistrationService]
})

export class PatientRegistrationComponent extends BaseComponent implements OnInit {

    regexSpecialCharacter = '[\x20-\x2F\x3A-\x40\x5B-\x60\x7b-\x7e\xA0-\xA3\xA5\xA7\xA9-\xB3\xB5-\xB7\xB9-\xBB\xBF-\xFF\u20AC\u0160\u0161\u017D\u017E\u0152\u0153\u0178]'; // ISO 8859-15
    registerSuccess = false;

    constructor(public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public appService: AppService,
        public route: ActivatedRoute,
        public patientRegistrationService: PatientRegistrationService,
        public translate: TranslateService,
        @Inject('defaultLanguage') public defaultLanguage: string,
        private cdr: ChangeDetectorRef,
        public fb: FormBuilder) 
    {
        super(authService, router, baseService, appService);
    }

    showhideBtn = [];
    languages = [];
    clinicId = 0;
    patientNumberCodeDE = ['OKP-DE', 'VVG-DE'];
    patientNumberCodeEN = ['OKP-EN', 'VVG-EN'];
    templates = {
        Sanitas   : {
            name : 'Sanitas',
            header : 'Sign up now for the Klenico Mental Health Check Sanitas',
            forms : [
                [
                    ['name', 'Given Name', 'form-group col-xs-12 col-lg-4 col-md-5', 'text', 'required', 'Given name is required', 'name-text'],
                    ['surname', 'Last Name', 'form-group col-xs-12 col-lg-4 col-md-5', 'text', 'required', 'Surname is required', 'last-name-text'],
                ],
                [
                    ['email', 'Email Address', 'form-group col-xs-12 col-lg-4 col-md-5', 'text', 'required', 'E-Mail address is required', 'email-text'],
                    ['confirm_email', 'Confirm E-Mail address', 'form-group col-xs-12 col-lg-4 col-md-5', 'text', 'required', 'Confirm E-Mail address is required', 'confirm-email-text']
                ],
                [
                    ['gender', 'Sex', 'form-group col-xs-12 col-lg-8 col-md-10', 'radio', 'optional', 'Date format is dd.mm.yyyy'],
                ],
                [
                    ['language_id', 'Language', 'form-group col-xs-12 col-lg-8 col-md-10', 'radio', 'optional', 'Date format is dd.mm.yyyy'],
                ]
            ]
        },
        Concordia   : {
            name : 'Concordia',
            header : 'Sign up now for the Klenico Mental Health Check Concordia',
            forms : [
                [
                    ['name','Given Name','col-xs-12 col-md-5 col-lg-4 form-group','text','required','Given name is required','name-text'],
                    ['surname', 'Last Name', 'col-xs-12 col-md-5 col-lg-4 form-group','text','required','Surname is required','last-name-text']
                ],
                [
                    ['email', 'Email Address', 'form-group col-xs-12 col-md-5 col-lg-4', 'text', 'required', 'E-Mail address is required', 'email-text'],
                    ['confirm_email', 'Confirm E-Mail address', 'form-group col-xs-12 col-lg-4 col-md-5', 'text', 'required', 'Confirm E-Mail address is required', 'confirm-email-text']
                ],
                [
                    ['birthday', 'Birthday', 'col-xs-12 col-md-5 col-lg-4 birtday-input', 'date', 'required', 'Date format is dd.mm.yyyy']
                ],
                [
                    ['gender', 'Sex', 'form-group col-xs-12 col-lg-8 col-md-10', 'radio', 'optional', 'Date format is dd.mm.yyyy']
                ],
                [
                    ['language_id', 'Language', 'form-group col-xs-12 col-lg-8 col-md-10', 'radio', 'optional', 'Date format is dd.mm.yyyy']
                ]
            ]
        },
        default     : ''
    };
    templateName = this.templates.default;
    languageId = 1;
    helpUrl = {
        de_CH : 'https://corporate.klenico.com/wp-content/uploads/2022/08/Datenschutzbestimmungen_Mentale_Gesundheitsanalyse_220617.pdf',
        en_GB : 'https://corporate.klenico.com/wp-content/uploads/2022/09/Privacy-Policy-Klenico-Mental-Health-Check-2022.pdf'
    }
    errorData = {};

    ngOnInit() {
        if (this.authService.isLoggedIn) {
            this.authService.logout();
        }

        this.setLanguage(this.defaultLanguage);
        this.languages = JSON.parse(localStorage.getItem('languages'));
        this.buildForm();

        this.form.valueChanges.subscribe((field) => {
            if (field.password !== '' || field.confirm_password !== '') {
                this.handleConfirmData('confirm_password', field.password, field.confirm_password);
            }
            
            if (field.email !== '' || field.confirm_email !== '') {
                this.handleConfirmData('confirm_email', field.email, field.confirm_email);
            }
        });

        this.route.params.subscribe(value => {
            if (value['clinicId']) {
                this.clinicId = value['clinicId'];
                this.patientRegistrationService.getClinicTemplate(this.clinicId).subscribe((res) => {
                    this.templateName = res['template_name'];
                    if (!res['can_register']) {
                        this.router.navigate(['/patient-registration']);
                    }

                    if (res['language']) {
                        this.languageId = res['language']['id'];
                        this.setLanguage(res['language']['locale']);
                    }
                });
                this.buildForm();
            }

            if (value['patientNumber']) {
                this.form.controls['number'].setValue(value['patientNumber']);

                let lang = this.languages[0];
                if (this.patientNumberCodeDE.indexOf(value['patientNumber']) >= 0) {
                    lang = this.languages.find(item => item.code === "DE");
                }

                if (this.patientNumberCodeEN.indexOf(value['patientNumber']) >= 0) {
                    lang = this.languages.find(item => item.code === "EN");
                }
                this.form.controls['language_id'].setValue(lang.id);
                this.setLanguage(lang.locale);
            }
        });
        this.appService.isLoading = false;
    }

    handleConfirmData(validateField, data, confirmData ) {
        if (data !== confirmData) {
            this.form.controls[validateField].setErrors({ mismatch: true });
        } else if (confirmData === '') {
            this.form.controls[validateField].setErrors({ required: true });
        } else {
            this.form.controls[validateField].setErrors(null);
        }
    }

    buildForm(): void {
        this.form = this.fb.group({
            'email': ['', [Validators.pattern('^$|[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]],
            'confirm_email': ['', [Validators.pattern('^$|[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]],
            'surname': ['', [Validators.required]],
            'name': ['', [Validators.required]],
            'birthday' : [''],
            'gender': [''],
            'context': [''],
            'number': [''],
            'language_id': [1],
            'password': ['', [Validators.minLength(8),this.appService.regexpValidator('\\d','haveNumber'),this.appService.regexpValidator(this.regexSpecialCharacter,'haveSpecialCharacter')]],
            'confirm_password': ['', [Validators.required]],
            'checked': [false]
        });

        if (this.clinicId) {
            this.form.controls['password'].setValidators([]);
            this.form.controls['confirm_password'].setValidators([]);
        }
    }

    submit(data, isValid) {
        this.formSubmitted = true;
        if (!isValid) {
            return;
        }

        this.resetErrors();
        this.isLoading = true;

        this.patientRegistrationService.register(data, this.clinicId).subscribe((res) => {
            this.isLoading = false;
            this.formSubmitted = false;
            this.registerSuccess = true;
        },
        (error) => {
            this.isLoading = false;
            this.errorMessage = error.error.error;
            if (data) {
                this.errorData = error.error.data;
            }
        });
    }

    setLanguage(locale: string): void {
        this.translate.use(locale);
        if (this.form) {
            this.cdr.detectChanges();
        }
        localStorage.setItem('language', locale);
    }

    isActive(locale: string): string {
        const language = localStorage.getItem('language');

        if (language === locale || this.translate.currentLang === locale) {
            return '--active';
        }

        if (language == null && this.translate.currentLang == null && locale === 'de_CH') {
            return '--active';
        }

        return '';
    }
}
